module.exports = __webpack_public_path__ + "img/EC2.a23e36bd.png";